import { useEffect, useMemo, useState } from 'react'
import { watchMembers } from '../../lib/members.js'

// Shared members map — memberId → member record. Any module can resolve a
// member's name/phone for display.
export function useMembersMap() {
  const [map, setMap] = useState({})
  useEffect(() => { const off = watchMembers(setMap); return () => off() }, [])
  return map
}

export function memberName(map, id) {
  return (map && map[id] && map[id].name) || (id ? '(unknown member)' : '—')
}

// Searchable member <select>. `value` is a memberId (or '' for none).
// Optional so walk-in records can skip a member.
export default function MemberPicker({ value, onChange, optional = true, label = 'Member' }) {
  const map = useMembersMap()
  const [q, setQ] = useState('')
  const members = useMemo(() =>
    Object.values(map || {}).filter(Boolean).sort((a, b) => (a.name || '').localeCompare(b.name || '')),
  [map])
  const filtered = q.trim()
    ? members.filter((m) => `${m.name} ${m.memberNumber || ''} ${m.phone || ''}`.toLowerCase().includes(q.trim().toLowerCase()))
    : members

  return (
    <div>
      {label ? <span className="block text-[11px] font-bold uppercase tracking-wide text-gray-500 mb-0.5">{label}</span> : null}
      <input className="input w-full mb-1" placeholder="Filter members…" value={q} onChange={(e) => setQ(e.target.value)} />
      <select className="input w-full" value={value || ''} onChange={(e) => onChange(e.target.value)}>
        <option value="">{optional ? '— none / walk-in —' : '— select member —'}</option>
        {filtered.map((m) => (
          <option key={m.id} value={m.id}>{m.name}{m.memberNumber ? ` (#${m.memberNumber})` : ''}</option>
        ))}
      </select>
    </div>
  )
}
